class dataManager {
    constructor() {
        this.worker = new Worker('assets/js/worker_dataManager.js')
        this.worker.onmessage = this.handleWorkerMessage.bind(this)
        this.callbacks = new Map()
    }

    handleWorkerMessage(event) {
        const { reqId, data } = event.data
        const callbacks = this.callbacks.get(reqId) || []

        // Trigger each callback and remove it
        callbacks.forEach((callback) => callback(data))
        this.callbacks.delete(reqId)
    }

    addCallback(reqId, callback) {
        if (!this.callbacks.has(reqId)) {
            this.callbacks.set(reqId, [])
        }
        this.callbacks.get(reqId).push(callback)
    }

    get(query, callback) {
        let action = ''
        if (query.identifier) {
            switch (query.type) {
                case 'cast':
                case 'timeline':
                    action = 'getCastsByDevice'
                    break
                case 'location':
                    action = 'getLocationsByDevice'
                    break
                case 'frame':
                    action = 'getFramesByCast'
                    break
                default:
                    action = 'getData'
                    break
            }
        } else {
            action = 'getAll'
        }

        let reqId = `${action}-${query.type}-${query.identifier}-${query.limit}`
        //console.log('reqId', reqId);
        this.addCallback(reqId, callback)
        this.worker.postMessage({ reqId: reqId, action: action, type: query.type, identifier: query.identifier, limit: query.limit })
    }

    set(type, data) {
        this.worker.postMessage({ action: 'setData', type: type, data: data })
    }
}

module.exports = dataManager
